import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  createStripeSetupIntent,
  clearStripeSetupIntent,
  updateBillingPlan,
  clearUpdateBillingPlan,
  validateStripeCoupon,
  clearValidateStripeCoupon,
} from 'redux/billing/actions';
import { patchUser, clearPatchUser } from 'redux/settings/actions';
import { fetchMe } from 'redux/users/actions';

import {
  CardElement,
  injectStripe,
} from 'react-stripe-elements';
import { Form } from 'semantic-ui-react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import TextField from 'components/redux-form-adapters/TextField';
import SelectField from 'components/redux-form-adapters/SelectField';
import { Checkbox } from 'semantic-ui-react';

import CommonLoader from 'components/common/CommonLoader';
import PlanModeSelector from 'components/dashboard/billing-content/PlanModeSelector';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';
import FixedNotification from 'components/common/FixedNotification';
import PaypalButton from 'components/dashboard/billing-content/PaypalButton';
import CryptopayButton from 'components/dashboard/billing-content/CryptopayButton';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import validate from './validate';

import './UpdateBillingPlanForm.css';


class UpdateBillingPlanForm extends Component {
  static propTypes = {
    createStripeSetupIntent: PropTypes.func.isRequired,
    clearStripeSetupIntent: PropTypes.func.isRequired,
    updateBillingPlan: PropTypes.func.isRequired,
    clearUpdateBillingPlan: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    fetchMe: PropTypes.func.isRequired,
    validateStripeCoupon: PropTypes.func.isRequired,
    clearValidateStripeCoupon: PropTypes.func.isRequired,
    me: PropTypes.object,
    countries: PropTypes.arrayOf(PropTypes.shape),
    billingPlans: PropTypes.arrayOf(PropTypes.shape),
    billingPlansError: PropTypes.object,
    stripeSetupIntent: PropTypes.object,
    stripeSetupIntentError: PropTypes.object,
    stripeCouponSuccess: PropTypes.object,
    stripeCouponError: PropTypes.object,
    proPlan: PropTypes.object.isRequired,
    countryId: PropTypes.number,
    patchUserSuccess: PropTypes.object,
    userBillingPlanUpdated: PropTypes.bool,
    userBillingPlanUpdateError: PropTypes.object,
    valid: PropTypes.bool,
    couponValue: PropTypes.string,
  };

  static defaultProps = {
    me: null,
    countries: null,
    billingPlans: null,
    billingPlansError: null,
    stripeSetupIntent: null,
    stripeSetupIntentError: null,
    stripeCouponSuccess: null,
    stripeCouponError: null,
    countryId: null,
    patchUserSuccess: null,
    userBillingPlanUpdated: null,
    userBillingPlanUpdateError: null,
    valid: null,
    couponValue: null,
  };

  state = {
    postToStripe: false,
    interval: 'month',
    planUpdatedNotification: false,
    paymentError: null,
    canMakePayment: false,
    paymentRequest: null,
    paymentRequestError: false,
    paymentMethod: null,
    paymentMethodID: null,
    paymentEvent: null,
    activePaymentMethod: 'credit-card',
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.patchUserSuccess &&
      prevProps.patchUserSuccess !== this.props.patchUserSuccess
    ) {
      this.props.fetchMe();
      this.props.clearPatchUser();
    }

    if (!prevProps.stripeSetupIntent && this.props.stripeSetupIntent) {
      this._updateBillingPlan();
    }

    if (!this.props.me.country && !prevProps.countryId && this.props.countryId) {
      this._updateCountry();
    } else if (
      this.props.me.country &&
      this.props.countryId &&
      this.props.initialValues.initialCountryId !== this.props.countryId
    ) {
      this._updateCountry();
    }

    if (prevProps.stripeCouponSuccess !== this.props.stripeCouponSuccess) {
      if (this.state.paymentRequest) {
        this.state.paymentRequest.update({
          total: {
            label: i18n.t("HeyLink.me PRO Subscription"),
            amount: this._getAmount(this.state.interval),
          },
        });
      }
    }

    if (!prevProps.userBillingPlanUpdated && this.props.userBillingPlanUpdated) {
      this.setState({ planUpdatedNotification: true });
      setTimeout(() => {
        this.props.fetchMe();
      }, 1000);
    }

    if (
      (!this.state.paymentRequest && !this.state.paymentRequestError &&
        this.props.me && this.props.me.country && this.props.proPlan
      ) ||
      (
        prevProps.me.country !== this.props.me.country ||
        prevProps.proPlan !== this.props.proPlan
      )
    ) {
      try {
        const paymentRequest = this.props.stripe.paymentRequest({
          country: this.props.me.country.code,
          currency: 'usd',
          total: {
            label: i18n.t("HeyLink.me PRO Subscription"),
            amount: this._getAmount(this.state.interval),
          },
        });

        const _thisRef = this;
        paymentRequest.on('paymentmethod', function(ev) {
          _thisRef.setState({ paymentMethod: 'browser' });
          _thisRef.setState({ paymentMethodID: ev.paymentMethod.id });
          _thisRef._createStripeSetupIntent();
          _thisRef.setState({ paymentEvent: ev });
        });

        paymentRequest.canMakePayment().then((result) => {
          this.setState({canMakePayment: result});
        });

        this.setState({paymentRequest: paymentRequest});
        this.setState({paymentRequestError: false});
      } catch(e) {
        this.setState({paymentRequest: null});
        this.setState({canMakePayment: false});
        this.setState({paymentRequestError: true});
      }
    }
  }

  componentWillUnmount() {
    this.setState({ paymentError: null });
    this.props.clearValidateStripeCoupon();
  }

  _getAmount = interval => {
    let amount = 0;
    if (interval === 'year') {
      amount = this.discountPriceDecorator(this.props.proPlan.annual_price) * 100;
    } else {
      amount = this.discountPriceDecorator(this.props.proPlan.monthly_price) * 100;
    }
    return Math.round(amount);
  }

  setPlanMode = interval => {
    this.setState({ interval });
    if (this.state.paymentRequest) {
      this.state.paymentRequest.update({
        total: {
          label: i18n.t("HeyLink.me PRO Subscription"),
          amount: this._getAmount(interval),
        },
      });
    }
  };

  discountPriceDecorator = price => {
    const { stripeCouponSuccess } = this.props;
    let percentOff = stripeCouponSuccess &&
      Number(stripeCouponSuccess.percent_off) || null;
    let amountOff = stripeCouponSuccess &&
      Number(stripeCouponSuccess.amount_off) || null;
    let value = Number(price).toFixed(2);

    if (this.props.stripeCouponSuccess) {
      if (percentOff) {
        return (value * (100 - percentOff) / 100).toFixed(2);
      }
      if (amountOff) {
        return (value - amountOff / 100).toFixed(2);
      }
    }
    return value;
  };

  _onValidateDiscountCode = () => {
    this.props.validateStripeCoupon(
      this.props.couponValue,
      this.props.proPlan.id,
      this.state.interval,
    );
  };

  _onClearDiscountCode = () => {
    this.props.change('coupon_value', null);
    this.props.clearValidateStripeCoupon();
  };

  isEnableDiscountSubmitForm = () => {
    if (!this.props.couponValue || this.props.stripeCouponSuccess) {
      return true;
    }
    return false;
  };

  _updateCountry = () => {
    const form = new FormData();
    form.append('country_id', this.props.countryId);
    this.props.patchUser(form);
  };

  _createStripeSetupIntent = () => {
    this.props.createStripeSetupIntent(this.props.proPlan.id, this.state.interval);
  };

  _updateBillingPlan = () => {
    const cardElement = this.props.elements.getElement('card');
    this.setState({
      postToStripe: true,
      paymentError: null,
    });

    let confirmCardSetupData = null;
    let handleActions = null;
    if (this.state.paymentMethod === 'card') {
      confirmCardSetupData = {
        payment_method: {
          card: cardElement,
        },
      };
      handleActions = true;
    } else if(this.state.paymentMethod === 'browser') {
      confirmCardSetupData = {
        payment_method: this.state.paymentMethodID,
      };
      handleActions = false;
    }

    this.props.stripe.confirmCardSetup(
      this.props.stripeSetupIntent.client_secret,
      confirmCardSetupData,
      {handleActions: handleActions},
    ).then(result => {
      if (result.error){
        this.setState({ paymentError: result.error });
      }
      this.setState({ postToStripe: false });
      this.props.updateBillingPlan(
        this.props.proPlan.id,
        result.setupIntent.payment_method,
        this.state.interval,
        this.props.couponValue,
      );
      if (this.state.paymentEvent) {
        this.state.paymentEvent.complete('success');
      }
    }).catch(error => {
      this.setState({
        postToStripe: false,
      });
      if (this.state.paymentEvent) {
        this.state.paymentEvent.complete('fail');
      }
    });

    this.props.clearStripeSetupIntent();
  };

  _onHandleSubmit = () => {
    const { me, countryId, initialValues } = this.props;
    this.setState({ postToStripe: true });
    this.setState({ paymentMethod: 'card' });

    if (me.country) {
      this._createStripeSetupIntent();
    }
  };

  render() {
    const {
      me,
      countries,
      billingPlans,
      proPlan,
      valid,
      stripeSetupIntentError,
      userBillingPlanUpdateError,
      couponValue,
      stripeCouponSuccess,
      stripeCouponError,
    } = this.props;

    const { postToStripe, interval, planUpdatedNotification, activePaymentMethod } = this.state;

    if (!me || !billingPlans || !proPlan) return null;

    const countriesOptions = countries ?
      countries.map(
        country => (
          { key: country.code, text: country.name, value: country.id }
        ),
      ) : [];

    if (!this.props.countryId && this.props.initialValues.initialCountryId) {
      this.props.change('country_id', this.props.initialValues.initialCountryId);
    }

    const isApplyDiscountDisabled = stripeCouponSuccess ||
      !couponValue || activePaymentMethod === 'paypal';

    return (
      <Translation>
        {(t) => (
          <div className="update-billing-plan-form__component">
            {/* Loader */}
            <CommonLoader
              active={postToStripe}
              text={t("Hold tight! We are upgrading you to PRO!")}
            />

            {/* Header */}
            <div className="title">{t("Your subscription")}</div>
            <div className="subtext">
              {t("You're nearly there, complete the fields below " +
                 "to get access to the full suite of HeyLink.me PRO features.")}
            </div>

            <div className="cost-block">
              <div className="cost-value">
                {proPlan &&
                  <Fragment>
                    {interval === 'year' ?
                      <div>
                        <span>
                          ${this.discountPriceDecorator(proPlan.annual_price)} USD&nbsp;
                        </span> / {t("year")}
                      </div>
                      :
                      <div>
                        <span>
                          ${this.discountPriceDecorator(proPlan.monthly_price)} USD&nbsp;
                        </span> / {t("month")}
                      </div>
                    }
                  </Fragment>
                }
              </div>
              <PlanModeSelector setPlanMode={this.setPlanMode} />
            </div>

            <div className="cost-subtext">
              {proPlan && !stripeCouponSuccess &&
                <Fragment>
                  {interval === 'year' ?
                    <div>
                      <strike>${proPlan.monthly_price}</strike>&nbsp;
                      ${proPlan.monthly_price_annual} / {t("month")}:
                      {t("save")} {proPlan.annual_price_discount}% {t("on the yearly plan")}
                    </div>
                    :
                    <div>{t("Save")} {proPlan.annual_price_discount}% {t("on the yearly plan")}</div>
                  }
                </Fragment>
              }
            </div>

            {/* Form */}
            <Form
              onSubmit={this._onHandleSubmit}
              error={!valid}
            >
              <div className="fields-wrapper">
                <div className="country-field">
                  <Field
                    search
                    component={SelectField}
                    name="country_id"
                    loading={countriesOptions.length === 0}
                    options={countriesOptions}
                    placeholder={t("Select your country")}
                    onBlur={(e) => e.preventDefault()}
                    required
                  />

                  {/* Error */}
                  {!valid &&
                    <div className="field-undertext error">
                      {t("Please select your country to upgrade billing plan")}
                    </div>
                  }
                </div>

                <div className="discount-code-field">
                  <div className="field-content">
                    <Field
                      component={TextField}
                      name="coupon_value"
                      type="text"
                      placeholder={t("Discount code")}
                      disabled={stripeCouponSuccess}
                    />
                    {!stripeCouponSuccess ?
                      <div
                        className={`apply-button${isApplyDiscountDisabled ? ' disabled' : ''}`}
                        onClick={() => {
                          if (!isApplyDiscountDisabled) {
                            this._onValidateDiscountCode();
                          }
                        }}
                      >
                        {t("Apply")}
                      </div>
                      :
                      <div
                        className={`apply-button clear`}
                        onClick={() => { this._onClearDiscountCode(); }}
                      >
                        {t("Clear")}
                      </div>
                    }
                  </div>
                  {!stripeCouponSuccess &&
                    !stripeCouponError &&
                    (!couponValue ||
                      (couponValue && !stripeCouponError)) &&
                    <div className="field-undertext">
                      {t("You might have received a discount code. " +
                         "Please enter it above")}
                    </div>
                  }

                  {stripeCouponError && stripeCouponError.error &&
                    <div className="field-undertext error">
                      {stripeCouponError.error}
                    </div>
                  }

                  {stripeCouponError && !stripeCouponError.error &&
                    <div className="field-undertext error">
                      {t("This discount code is not valid or has expired")}
                    </div>
                  }

                  {this.state.activePaymentMethod === 'paypal' && couponValue &&
                    <div className="field-undertext error">
                      {t("Sorry, discount can only be applied for the credit " +
                         "card payments, Google or Apple Pay")}
                    </div>
                  }

                  {stripeCouponSuccess &&
                    <div className="field-undertext">
                      <div className="icon success" />
                      <div>{t("You have successfully applied the discount code")}</div>
                    </div>
                  }
                </div>

                {/* Credit Card Section */}
                <div
                  className={`payment-section${this.state.activePaymentMethod === 'credit-card' ? ' active' : '' }`}
                  tabIndex={-1}
                  onClick={() => { this.setState({ activePaymentMethod: 'credit-card' }); }}
                  role="button"
                >
                  <div className="section-header">
                    <Checkbox
                      radio
                      checked={this.state.activePaymentMethod === 'credit-card'}
                      onChange={() => { this.setState({ activePaymentMethod: 'credit-card' }); }}
                    />
                    <div className="title-text">{t("Credit Card")}</div>
                    <div className="icons-block">
                      <div className="icon visa" />
                      <div className="icon mastercard" />
                      <div className="icon amex" />
                      <div className="icon discover" />
                    </div>
                  </div>
                  {this.state.activePaymentMethod === 'credit-card' &&
                    <div className="payment-form">
                      <CardElement />
                      <div className="secured-text">
                        <div className="icon" />
                        <div className="text">{t("Your transaction is secured with SSL encryption")}</div>
                      </div>
                      <Button
                        submit
                        disabled={!valid || !this.isEnableDiscountSubmitForm()}
                      >
                        {t("Upgrade to PRO")}
                      </Button>
                    </div>
                  }
                </div>

                {/* Paypal Section */}
                <div
                  className={`payment-section${this.state.activePaymentMethod === 'paypal' ? ' active' : '' }`}
                  tabIndex={-1}
                  onClick={() => { this.setState({ activePaymentMethod: 'paypal' }); }}
                  role="button"
                >
                  <div className="section-header">
                    <Checkbox
                      radio
                      checked={this.state.activePaymentMethod === 'paypal'}
                      onChange={() => { this.setState({ activePaymentMethod: 'paypal' }); }}
                    />
                    <div className="title-text">PayPal</div>
                    <div className="icons-block">
                      <div className="icon paypal" />
                    </div>
                  </div>
                  {this.state.activePaymentMethod === 'paypal' &&
                    <div className="payment-form">
                      <PaypalButton
                        interval={interval}
                        disabled={!valid}
                      />
                    </div>
                  }
                </div>

                {/* Cryptopay Section */}
                <div
                  className={`payment-section${this.state.activePaymentMethod === 'cryptopay' ? ' active' : '' }`}
                  tabIndex={-1}
                  onClick={() => { this.setState({ activePaymentMethod: 'cryptopay' }); }}
                  role="button"
                >
                  <div className="section-header">
                    <Checkbox
                      radio
                      checked={this.state.activePaymentMethod === 'cryptopay'}
                      onChange={() => { this.setState({ activePaymentMethod: 'cryptopay' }); }}
                    />
                    <div className="title-text">Crypto.com</div>
                    <div className="icons-block">
                      <div className="icon cryptopay" />
                    </div>
                  </div>
                  {this.state.activePaymentMethod === 'cryptopay' &&
                    <div className="payment-form">
                      <CommonMessage info>
                        {t("Crypto.com Payment is not available in Incognito mode")}
                      </CommonMessage>
                      <CryptopayButton
                        interval={interval}
                        disabled={!valid}
                      />
                    </div>
                  }
                </div>

                {/* Google Pay Section */}
                {this.state.canMakePayment && !this.state.canMakePayment.applePay &&
                  <div
                    className={`payment-section${this.state.activePaymentMethod === 'google-pay' ? ' active' : '' }`}
                    tabIndex={-1}
                    onClick={() => { this.setState({ activePaymentMethod: 'google-pay' }); }}
                    role="button"
                  >
                    <div className="section-header">
                      <Checkbox
                        radio
                        checked={this.state.activePaymentMethod === 'google-pay'}
                        onChange={() => { this.setState({ activePaymentMethod: 'google-pay' }); }}
                      />
                      <div className="title-text">Google Pay</div>
                      <div className="icons-block">
                        <div className="icon google-pay" />
                      </div>
                    </div>
                    {this.state.activePaymentMethod === 'google-pay' &&
                      <div className="payment-form">
                        <div className="pay-text">
                          <div>
                            {t("By completing your checkout, you acknowledge that " +
                               "your subscription will automatically renew, and " +
                                "your credit card will be charged the subscription " +
                                "fees until you cancel your subscription.")}
                          </div>
                          <div>{t("You may cancel your subscription at any time.")}</div>
                        </div>
                        <a
                          className="pay-button gpay"
                          onClick={e => this.state.paymentRequest.show()}
                        >
                          <div className="text">{t("Subscribe with")}</div>
                          <div className="icon gpay" />
                        </a>
                      </div>
                    }
                  </div>
                }

                {/* Apple Pay Section */}
                {this.state.canMakePayment && this.state.canMakePayment.applePay &&
                  <div
                    className={`payment-section${this.state.activePaymentMethod === 'apple-pay' ? ' active' : '' }`}
                    tabIndex={-1}
                    onClick={() => { this.setState({ activePaymentMethod: 'apple-pay' }); }}
                    role="button"
                  >
                    <div className="section-header">
                      <Checkbox
                        radio
                        checked={this.state.activePaymentMethod === 'apple-pay'}
                        onChange={() => { this.setState({ activePaymentMethod: 'apple-pay' }); }}
                      />
                      <div className="title-text">Apple Pay</div>
                      <div className="icons-block">
                        <div className="icon apple-pay" />
                      </div>
                    </div>
                    {this.state.activePaymentMethod === 'apple-pay' &&
                      <div className="payment-form">
                        <div className="pay-text">
                          <div>
                            {t("By completing your checkout, you acknowledge that " +
                               "your subscription will automatically renew, and " +
                                "your credit card will be charged the subscription " +
                                "fees until you cancel your subscription.")}
                          </div>
                          <div>{t("You may cancel your subscription at any time.")}</div>
                        </div>
                        <a
                          className="pay-button apay"
                          onClick={e => this.state.paymentRequest.show()}
                        >
                          <div className="text">{t("Subscribe with")}</div>
                          <div className="icon apay" />
                        </a>
                      </div>
                    }
                  </div>
                }

              </div>

              <div className="form-undertext">
                {t("By subscribing you agree to")} HeyLink.me&nbsp;
                <a href={`${PUBLIC_SITE_URL}/terms/`} target="_blank">{t("Terms")}</a>&nbsp;
                &&nbsp;&nbsp;<a href={`${PUBLIC_SITE_URL}/privacy/`} target="_blank">{t("Policies")}</a>
              </div>

            </Form>

            {/* Errors */}
            <div className="errors-block">
              {stripeSetupIntentError &&
                <CommonMessage
                  error
                  errors={stripeSetupIntentError}
                />
              }

              {userBillingPlanUpdateError &&
                <CommonMessage
                  error
                  errors={userBillingPlanUpdateError}
                />
              }

              {this.state.paymentError &&
                <CommonMessage error>
                  {this.state.paymentError.message}
                </CommonMessage>
              }
            </div>

            {/* Notifications */}
            {planUpdatedNotification &&
              <FixedNotification
                fullscreen
                onFadeComplete={() => this.setState({ planUpdatedNotification: false }) }
              >
                <h2>{t("Congratulations!")}</h2>
                <br />
                <div>{t("Your account was successfully")}</div>
                <div>{t("upgraded to PRO")}</div>
              </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const setInitialValues = params => {
  const countryId = (params.country && params.country.id) || null;
  return {
    initialCountryId: countryId,
  };
};

const mapStateToProps = state => {
  const selector = formValueSelector('UpdateBillingPlanForm');
  return {
    countryId: selector(state, 'country_id'),
    couponValue: selector(state, 'coupon_value'),
    me: state.usersReducer.me,
    billingPlans: state.billingReducer.billingPlans,
    billingPlansError: state.billingReducer.billingPlansError,
    stripeSetupIntent: state.billingReducer.stripeSetupIntent,
    stripeSetupIntentError: state.billingReducer.stripeSetupIntentError,
    userBillingPlanUpdated: state.billingReducer.userBillingPlanUpdated,
    stripeCouponSuccess: state.billingReducer.stripeCouponSuccess,
    stripeCouponError: state.billingReducer.stripeCouponError,
    userBillingPlanUpdateError: state.billingReducer.userBillingPlanUpdateError,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    initialValues: setInitialValues(state.usersReducer.me),
  };
};

export default injectStripe(connect(
  mapStateToProps,
  {
    createStripeSetupIntent,
    clearStripeSetupIntent,
    updateBillingPlan,
    clearUpdateBillingPlan,
    patchUser,
    clearPatchUser,
    fetchMe,
    validateStripeCoupon,
    clearValidateStripeCoupon,
  },
)(reduxForm({
  form: 'UpdateBillingPlanForm',
  validate,
})(UpdateBillingPlanForm)));
